export const os_type_en = {
  "IOS": "IOS",
  "ANDROID": "Android",
};
